module.exports = __webpack_public_path__ + "media/images/categories/carousel/industries-a5c423975e9c87ca32a0ea29f5c74f27.jpg";